import React, { useEffect, useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { useStyles } from "./style";
import { actionCreators } from "./action";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Copyright from "../../components/Copyright";
import Alert from "@material-ui/lab/Alert";
import AppleIcon from "@material-ui/icons/Apple";
import { useAddToHomescreenPrompt } from "../../helpers/useAddToHomescreeenPrompt";
import AndroidIcon from "@material-ui/icons/Android";
import isPWA from "../../helpers/isPWA";
import isIOS from "../../helpers/isIOS";


function Login(props) {
  const classes = useStyles();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    user && props.putUser(user);
  });

  const [state, setState] = useState({
    email: "",
    password: ""
  });

  const [prompt, promptToInstall] = useAddToHomescreenPrompt();
  const [isVisible, setVisibleState] = React.useState(!isIOS);
  const [isCreateAccount, setIsCreateAccount] = React.useState(false);

  const hide = () => setVisibleState(false);

  React.useEffect(() => {
    promptToInstall();
    if (prompt) {
      setVisibleState(true);
    }
  }, [prompt]);

  return props.uid ? (
    <Redirect to="/inbox" />
  ) : (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        {isVisible && (
          <Alert onClose={hide} severity="info">
            <b>
              I believe that everyone can regain control of their affairs. Keep
              them always at your fingertips. ZenGTD is available on{" "}
            </b>
            <Grid item xs={12} sm={12} md={12}>
              <img src="./pngbarn.png" style={{ width: 24, height: 24 }} />
              <AndroidIcon />
              <AppleIcon />
            </Grid>
            <Button
              onClick={promptToInstall}
              color="secondary"
              variant="contained"
            >
              Install
            </Button>
            or use it in Browser.
          </Alert>
        )}

        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {isCreateAccount ? "Create Account " : "Sign in"}
          </Typography>
          <form className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={state.email}
              onChange={e => setState({ ...state, email: e.target.value })}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={state.password}
              onChange={e => setState({ ...state, password: e.target.value })}
            />
            <Grid container>
              <Grid item xs>
                {!isIOS && (
                  <Link href="#" variant="body2" onClick={promptToInstall}>
                    Install zenGTD
                  </Link>
                )}{" "}
                <img src="./pngbarn.png" style={{ width: 15, height: 15 }} />
                <AndroidIcon style={{ width: 15, height: 15 }} />
                <AppleIcon style={{ width: 15, height: 15 }} />
              </Grid>

              <Grid item>
                <Link
                  href="#"
                  variant="body2"
                  onClick={e => {
                    e.preventDefault();
                    setIsCreateAccount(!isCreateAccount); 
                  }}
                >
                  {isCreateAccount ? "Login" : "Create Account"}
                </Link>
              </Grid>
            </Grid>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="secondary"
              className={classes.submit}
              onClick={e => {
                e.preventDefault();
                isCreateAccount ?  
                props.createAccount(state) : 
                props.loginWithLoginAndPassword(state);

               
              }}
            >
                 {isCreateAccount ? "Create Account " : "Login"}
            </Button>

            {/* {!(isIOS && isPWA) && ( */}
              <>
                <hr />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={e => {
                    e.preventDefault();
                    props.loginWithGoogle();
                  }}
                >
                  Sign In by google
                </Button>
              </>
            {/* )} */}
            <Box mt={5}>
              <Copyright />
            </Box>
          </form>
        </div>
      </Grid>
    </Grid>
  );
}

const mapStateToProps = state => ({
  uid: state.user && state.user.user.uid
});

export default connect(mapStateToProps, actionCreators)(Login);
